import theme from 'common/theme';
export const colors: Record<string, string> = {
  critical: theme.colors.error,
  warning: theme.colors.warning
};
